import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_URL } from '../../configurations/server-config';

@Injectable({
  providedIn: 'root'
})
export class RecetteService {

  constructor(private http: HttpClient) { }

  getAllbagage(page= 0, size= 100): any {
    return this.http.get(`${API_URL}/bagage?page=${page}&size=${size}`);
  }

  saverecette(recette: any): any {
    return this.http.post(`${API_URL}/recette`, recette, {
      observe: 'response',
    });
  }

  updatebus(bagage: any): any {
    return this.http.put(`${API_URL}/recette`, bagage, {
      observe: 'response',
    });
  }

  getrecetteinsession(session: any): any {
    return this.http.get(`${API_URL}/recettesession/${session}`);
  }

  getamountrecetteinsession(session: any): any {
    return this.http.get(`${API_URL}/amountrecettesession/${session}`);
  }

  getamountrecetteinsessionByPaymentMethod(session: any): any {
    return this.http.get(`${API_URL}/amountrecettesessionbypaymentmethod/${session}`);
  }

  getAllRecette(page= 0, size= 10): any {
    return this.http.get(`${API_URL}/recette?page=${page}&size=${size}`);
  }


  getallrecetteinSession(session: any, page: any, size: any): any {
    const types = 'autres recette';
    return this.http.get(`${API_URL}/recetteinsessions/${session}?t=${types}&page=${page}&size=${size}`);
  }

  getalldepenseinSession(session: any, page: any, size: any): any {
    const types = 'autres depenses';
    return this.http.get(`${API_URL}/recetteinsessions/${session}?t=${types}&page=${page}&size=${size}`);
  }

  getrecettesummary(session: any, type: any): any {
    return this.http.get(`${API_URL}/recettesummary?id=${session}&&ty=${type}`);
  }
}
